module.exports = __webpack_public_path__ + "static/632-c40332b08f3edd89fc0eadcabaa5fb97.png";